// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import moment from 'moment'
import { CANNOT_BE_MORE_THAN_35_DAYS } from 'errors'

const validateDateMoreThan35Days = v => {
  const m = moment(v, 'YYYY/MM/DD')
  const today = moment()
  const futureDate = moment(today).add(35, 'days')

  return (
    m.valueOf() > futureDate  && CANNOT_BE_MORE_THAN_35_DAYS
  )
}

export default validateDateMoreThan35Days
